import { useEffect, useState } from "react";
import "@/App.css";
import { CATEGORIES } from "@/data/menu";
import { useLenisScroll } from "@/hooks/useLenisScroll";
import { LoadingScreen } from "@/components/andariegos/LoadingScreen";
import { Hero } from "@/components/andariegos/Hero";
import { CategoryNav } from "@/components/andariegos/CategoryNav";
import { Marquee } from "@/components/andariegos/Marquee";
import { MenuSection } from "@/components/andariegos/MenuSection";
import { Footer } from "@/components/andariegos/Footer";
import { APP } from "@/constants/testIds";

function App() {
  const [loading, setLoading] = useState(true);
  useLenisScroll();

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 1400);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    document.documentElement.classList.add("andariegos-root");
    return () => document.documentElement.classList.remove("andariegos-root");
  }, []);

  // Marquee inserted after 3rd category for editorial rhythm
  const marqueeAfterIndex = 2;

  return (
    <div
      data-testid={APP.root}
      className="min-h-screen w-full bg-[#0a0906] text-[#f4e9d5] antialiased"
    >
      <LoadingScreen visible={loading} />
      <Hero />
      <CategoryNav />
      <main>
        {CATEGORIES.map((cat, i) => (
          <div key={cat.id}>
            <MenuSection category={cat} alt={i % 2 === 1} />
            {i === marqueeAfterIndex && <Marquee />}
          </div>
        ))}
      </main>
      <Footer />
    </div>
  );
}

export default App;
